module.exports = "<div ng-if=\"isLoading()\" class=\"div-centered-loading-image\"></div>\n<div ng-transclude></div>\n\n";